import axios from 'axios'
import qs from 'qs'
import store from '../store'
import router from '../router/router-mod.js'
const instance = axios.create({
  timeout: 15000,
})

const xhr = {
  get (url, data, config) {
    return new Promise((resolve, reject) => {
      instance.get(url, {params: data}, config).then(res => {
        resolve(res.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  fetch (url, data, config, methods) {
    return new Promise((resolve, reject) => {
      instance[methods](url, data, config).then(res => {
        resolve(res)
      }).catch(err => {
        reject(err)
      })
    })
  },
  post (url, data, config) {
    return this.fetch(url, data, config, 'post')
  }
}

//请求拦截器新增非get请求添加请求头和token
instance.interceptors.request.use(config => {
  config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
  // config.data = qs.stringify(config.data)
  let token = store.state.openid
  // let token="opFTiwr7p6sPot7Nr3kyU0ghvJgE";
  // if (token) {
  //   config.headers.Authorization = `Bearer ${token}`
  // }

  //get查询字符串加openid，post请求头加openid
  if (config.method != 'get') {
    config.data = qs.stringify({...config.data, openid: token})
  } else {
    config.params = {...config.params, openid: token}
  }
  return config
}, error => {
  return Promise.reject(error)
})

//响应拦截器
instance.interceptors.response.use(response => {
  // console.log(response)
  // 对响应数据做点什么
  return response
}, error => {
  if (error.response) {
    if (error.response.status == '401') {
		router.push({path:"/login"})
      // window.location.href = 'https://yzgsapi.ewangke.com/api/index/oauth'
    }
  }
  // 对响应错误做点什么

  return Promise.reject(error)
})

export default xhr



// WEBPACK FOOTER //
// ./src/axios/index.js